'use strict';

import ngResource from 'angular-resource';

function DailyMaxDemandPowerService ($resource) {
    return $resource(
        '/api/daily_max_demand_power/:id', { id: '@id' },
        {
            show: { method: 'GET', isArray: false }
        }
    )
}

export default angular.module('leptonApp.DailyMaxDemandPowerService', ['ngResource'])
    .factory('DailyMaxDemandPowerService', ['$resource', DailyMaxDemandPowerService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/daily_max_demand_power/daily_max_demand_power.service.js